import React, { useEffect } from "react";
import {MTPLVehicleTypeButton} from "./MtplVehicleTypeButton";
import vt_b from "../../../../../images/vehicle-types/vt_b.svg";
import vt_b_hov from "../../../../../images/vehicle-types/hover/vt_b_hov.svg";
import vt_b5 from "../../../../../images/vehicle-types/vt_b5.svg";
import vt_b5_hov from "../../../../../images/vehicle-types/hover/vt_b5_hov.svg"
import "./MtplVehicleTypeSelectionViewStyles.scss";
import {VehicleGroup} from "../../../../../model/vehicle";
import {MTPLTarifficationDescription} from "../MtplTarifficationDescription";
import {strings} from "../../../../../strings/strings";
import { useHotjar } from "../../../../../utils/hooks/useHotjar";

interface MTPLVehicleTypeSelectionView {
    onVehicleTypesSelect: (vehicleGroup: VehicleGroup) => void;
}

export const MTPLVehicleTypeSelectionViewSmartDrive = ({onVehicleTypesSelect}: MTPLVehicleTypeSelectionView) => {

    const { trackHotjar } = useHotjar()

    useEffect(() => {
        trackHotjar("select", "mtpl")
    }, [])

    return (
        <div className={"step-view vehicle-type-selection"}>
            <div className={"vehicle-type-selection__selection"}>
                <div className={"vehicle-type-selection__selection__header"}>
                    <span>{strings.vehicleTypeChoose}</span>
                </div>

                <div className={"vehicle-type-selection__selection__buttons"}>
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB'} title={strings.vehicleShortGroupB} image={vt_b} altImage={vt_b_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.B)
                                           }}/>
                    <MTPLVehicleTypeButton id={'vehicleShortGroupB5'} title={strings.vehicleShortGroupB5} image={vt_b5} altImage={vt_b5_hov}
                                           onClick={() => {
                                               onVehicleTypesSelect(VehicleGroup.B5)
                                           }}/>
                </div>
            </div>
            <div/>
            <div className={"vehicle-type-selection__description"}>
                <MTPLTarifficationDescription/>
            </div>
        </div>
    );
};